import { api } from "./configs/axiosConfigs";

export const MeetUpsAPI = {
  getMeets: async () => {
    const response = await api.get(
      `/meetups?page=1&items_per_page=2000&order_by=meetup_date&order=desc`,
    );

    return response?.data;
  },

  getMeet: async (id) => {
    const response = await api.get(`/meetups/${id}`);

    return response?.data;
  },

  addMeet: async (form) => {
    const response = await api.post(`/meetups`, form);

    return response?.data;
  },

  updateMeet: async (form, id) => {
    const response = await api.patch(`/meetups/${id}`, form);

    return response?.data;
  },

  deleteMeet: async (id) => {
    const response = await api.delete(`/meetups/${id}`);

    return response?.data;
  },
};
